export default __webpack_public_path__ + "2136ab66c2e9bff6538f5fcb009bdfb0.png";